import React from "react";
import "../../../../../Assets/Styles/DeleteAlert.scss";

const Alert = (props) => {
  const translateText = (LabelId) => {
    var Filter = "label_id";
    var Keyword = LabelId;
    var Label = props.LangData.filter((Obj) => {
      return Obj[Filter] === Keyword;
    });
    return Label[0].label_value;
  };
  return (
    <React.Fragment>
      {props.IsDelete ? (
        <div
          className={
            window.localStorage.getItem("MenuIsOpen") === "1"
              ? "alert-overlay"
              : "alert-overlay alert-overlay-big"
          }
        >
          <div className="outline" onClick={() => props.cancelDelete()}></div>
          <div className="alert-body">
            <section className="alert-head">
              <p className="title">
                {props.LangData ? translateText("delete_item") : "Delete item"}
              </p>
              <button onClick={() => props.cancelDelete()}>
                <i className="feather-x"></i>
              </button>
            </section>
            <p className="alert-text">
              {translateText("delet_item_modal_text")}
            </p>
            <div className="delete-footer">
              <button
                className="cancel-btn"
                onClick={() => props.cancelDelete()}
              >
                {translateText("cancel")}
              </button>
              <button
                className="delete-btn"
                onClick={() => props.acceptDelete()}
              >
                {translateText("delete")}
              </button>
            </div>
          </div>
        </div>
      ) : (
        <div
          className={
            window.localStorage.getItem("MenuIsOpen") === "1"
              ? "alert-overlay"
              : "alert-overlay alert-overlay-big"
          }
        >
          <div className="outline" onClick={() => props.cancel()}></div>
          <div
            className={
              props.BodyClassName
                ? "alert-body " + props.BodyClassName
                : "alert-body"
            }
            id={props.Id ? props.Id : null}
          >
            <section className="alert-head">
              <p className="title">{props.AlertText}</p>
              <button onClick={() => props.cancel()}>
                <i className="feather-x"></i>
              </button>
            </section>
            <p className="alert-text">{props.AlertInfo}</p>
            <div className="delete-footer alert-footer">
              {props.CancelIsHidden ? null : (
                <button className="cancel-btn" onClick={() => props.cancel()}>
                  {props.CancelText ? props.CancelText : "Cancel"}
                </button>
              )}
              <button
                className={
                  props.PrimaryBtnClassName
                    ? "delete-btn " + props.PrimaryBtnClassName
                    : "delete-btn"
                }
                onClick={() => props.accept()}
              >
                {props.AcceptText}
              </button>
            </div>
          </div>
        </div>
      )}
    </React.Fragment>
  );
};

export default Alert;
